import React, { useState } from 'react';
import { useController } from 'react-hook-form';
import { PhoneInput as _PhoneInput } from '@/ui/atoms/PhoneInput';

export const PhoneInput = ({ form, label, required, question, wide, boldLabel, ...props }) => {
  const [phone, setPhone] = useState();
  const {
    field: { ref, onChange, value, ...field },
    fieldState: { error }
  } = useController({
    ...form,
    defaultValue: ''
  });

  return (
    <_PhoneInput
      {...field}
      {...props}
      required={required}
      value={phone}
      setValue={setPhone}
      name={form.name}
      control={form.control}
      label={label}
      // codeError={error && error.type === 'isCode' && error.message}
      error={error}
      innerRef={ref}
      tooltip={question ? question.tooltip : ''}
      tooltip_RU={question ? question.tooltip_RU : ''}
      tooltip_LV={question ? question.tooltip_LV : ''}
      wide={wide}
      boldLabel={boldLabel}
    />
  );
};
